<template>
    <rkm-overlay>
        <rkm-layout-body title="Fechamento de consulta agendada">
            <template v-slot:actions>
                <rkm-button
                    @click="$refs.List.handleSave()"
                    color="primary"
                >
                    Finalizar
                </rkm-button>
            </template>
            <rkm-layout-content>
                <List ref="List" @saved="saved" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/fechamento-consulta/List'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: { List },
    created() {
        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        loaded(value) {
            this.additionals = value.additionals
            this.form = value.form
        },
        saved() {

            this.$refs.List.resetFormBusca()
        },
    },
}
</script>